import React, { useEffect, useState } from "react";
import { Button, Card, Table, Modal } from "antd";
import axios from "axios";
import CsvDownloader from "react-csv-downloader";
import {
  generateStringFilterFunc,
  getFilterValues,
} from "../../../util/HelperFuncs";
import { DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setStudentList, removeStudent } from "../../../reducer/student";
import store from "../../../store";

const { confirm } = Modal;

const deleteUser = (record) => {
  confirm({
    title: `${record.name} ${record.surName} isimli öğrenciyi silmek istediğinize emin misiniz?`,
    onOk() {
      axios
        .post(`/api/admin/removeUser`, {
          userId: record.id,
        })
        .then((response) => {
          if (response.data.success) {
            store.dispatch(removeStudent(record.id));
          }
        });
    },
  });
};

const columns = [
  {
    title: "Ad",
    dataIndex: "name",
  },
  {
    title: "Soyad",
    dataIndex: "surName",
  },
  {
    title: "Sınıf Seviyesi",
    dataIndex: "classLevel",
  },
  {
    title: "Cinsiyet",
    dataIndex: "gender",
    filters: [
      { text: "Erkek", value: "E" },
      { text: "Kadın", value: "K" },
    ],
    onFilter: (value, record) => record.gender.indexOf(value) === 0,
  },
  {
    title: "Telefon",
    dataIndex: "phone",
  },
  {
    dataIndex: "schoolName",
    title: "Okul",
    onFilter: generateStringFilterFunc("schoolName"),
    filterSearch: true,
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Veli Ad Soyad",
    dataIndex: "parentNameSurname",
  },
  {
    title: "Veli Tel",
    dataIndex: "parentMobile",
  },
  {
    title: "Kayıt Tarihi",
    dataIndex: "createDate",
    sorter: (a, b) => new Date(a.createDate) - new Date(b.createDate),
  },
  {
    title: "İşlemler",
    render: (record) => (
      <Button
        danger
        onClick={() => {
          deleteUser(record);
        }}
      >
        <DeleteOutlined />
        Öğrenciyi Sil
      </Button>
    ),
  },
];

const header = [
  {
    id: "name",
    displayName: "Ad",
  },
  {
    id: "surName",
    displayName: "Soyad",
  },
  {
    id: "classLevel",
    displayName: "Sınıf Seviyesi",
  },
  {
    id: "gender",
    displayName: "Cinsiyet",
  },
  {
    id: "phone",
    displayName: "Telefon",
  },
  {
    id: "school",
    displayName: "Okul",
  },
  {
    id: "email",
    displayName: "Email",
  },
  {
    id: "parentNameSurname",
    displayName: "Veli Ad Soyad",
  },
  {
    id: "parentMobile",
    displayName: "Veli Mobil",
  },
  {
    id: "createDate",
    displayName: "Kayıt Tarihi",
  },
];

const StudentList = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const students = useSelector((state) => state.student.studentList);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get("/api/admin/userList")
      .then((response) => {
        if (response.data.success) {
          dispatch(setStudentList(response.data.data));
          columns[5].filters = getFilterValues(
            response.data.data,
            "schoolName"
          );
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <Card title="Öğrenci Listesi">
      {students.length > 0 && (
        <CsvDownloader
          style={{ display: "inline-block", marginBottom: 16 }}
          datas={students}
          filename="ogrenci-listesi"
          columns={header}
          separator=";"
        >
          <Button type="primary">Excele aktar</Button>
        </CsvDownloader>
      )}
      <Table
        bordered
        scroll={{ x: 400 }}
        columns={columns}
        rowKey={(user) => user.id}
        dataSource={students}
        loading={isLoading}
      />
    </Card>
  );
};

export default StudentList;
